var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.375 13.375L16.75 9M16.75 9L12.375 4.625M16.75 9H6.25M6.25 16.875H2.75C2.28587 16.875 1.84075 16.6906 1.51256 16.3624C1.18437 16.0342 1 15.5891 1 15.125V2.875C1 2.41087 1.18437 1.96575 1.51256 1.63756C1.84075 1.30937 2.28587 1.125 2.75 1.125H6.25",
    stroke: "#F5F5F5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.ebd5d45cf635a66dc0057631a9b55ded.svg";
export { ForwardRef as ReactComponent };